import config from '../../config.json';
import Cookie from 'js-cookie';

import store from '../store/index';

/**
 * Check subject from object
 *
 * @return {boolean}
 */
export function validateIncludes(object, search) {
    try {
        return object.includes(search)
    } catch (e) {
        let status = false
        for (var i = 0; i < object.length; i++) {
            if (object[i] == search) {
                status = true;
                break;
            }
        }
        return status
    }
}

/**
 * Check if the url from allow host
 *
 * @return {boolean}
 */
export function allowFromHosts() {
    if (config && config.allow_hostnames) {
        // revisi
        return validateIncludes(config.allow_hostnames, location.hostname);
    }

    return false;
}

/**
 * Check if file type is image type
 *
 * @param {string} type
 * @return {boolean}
 */
export function isImage(filename) {
    return (/\.(gif|jpe?g|tiff|png)$/i).test(filename);
}

/**
 * Check if file type is audio type
 *
 * @param {string} filename
 * @return {boolean}
 */
export function isAudio(filename) {
    return (/\.(mp3|m4a|wav|mp4)$/i).test(filename);
}

/**
 * Get location.search / param by given key
 *
 * @param {string} name
 * @return {string}
 */
export function getParam(name) {
    let key = name
    if (name = (new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)')).exec(location.search)) {
        if (key == "fullname") return decodeURIComponent(name[1].replace(/\+/g, '%20'));
        return decodeURIComponent(name[1]);
    }
}

/**
 * Check if browser has last question cookie
 *
 * @return {boolean}
 */
export function hasLastQuestion() {
    let token = Cookie.get('org_token');

    let student = Cookie.get(`etest_${getParam('email')}`);

    return (student && token) ? true : false;
}

/**
 *
 * @param {Event} e
 */
export function handleUnload(e) {
    e.preventDefault();
    return e.returnValue = 'Are you sure you want to close?';
}

/**
 * redirect to result url if !ishow_pt_result and type == 'pt
 *
 * @param {string} url
 * @return {void}
 */
export function redirectToResultUrl(url) {
    document.querySelector('.spinner-box').classList.add('show');
    window.removeEventListener('beforeunload', handleUnload)
    location.href = url;
}

/**
 * Check if the given status param is 'done'
 *
 * @param {string} status
 * @return {boolean}
 */
export function isDone(status) {
    return status == 'done';
}

/**
 * Check if the given status param is 'complete'
 *
 * @param {string} status
 * @return {boolean}
 */
export function isComplete(status) {
    return status == 'completed';
}

/**
 * Check if all given param is all true
 *
 * @param {string} status
 * @param {string} type
 * @param {string} url
 * @return {boolean}
 */
export function shouldRedirectToResultUrl(status, type, url) {
    return isDone(status) && type == 'pt' && url != "";
}

/**
 * Get language list
 *
 * @param {string} key
 * @param {object} obj
 * @return {string}
 */
export function $lang(key, obj) {
    const tr = store.getState().translation;

    let lang = store.getState().lang;

    if (!lang || !tr[lang]) {
        lang = 'en';
    }

    let pattern = /\{([^}]+)\}/g;

    let translation = key.split('.').reduce((o, i) => o[i], tr[lang]);

    if (typeof translation != 'string') {
        return;
    }

    let placeholders = translation.match(pattern);

    if (translation) {
        if (placeholders && placeholders.length) {
            /**
             * placeholder is the name inside the curly brace. e.g {name} placeholders = ['name']
             *
             * @return {Array}
             */
            placeholders = placeholders.map(arr => arr.replace('{', '').replace('}', ''));

            for (let i = 0; i < placeholders.length; i++) {
                translation = translation.replace(new RegExp('{' + placeholders[i] + '}', 'gi'), obj[placeholders[i]]);
            }

            return translation;
        }

        return translation;
    }
}

/**
 * Determine the plan
 *
 * @param {any} data
 * @return {boolean|string}
 */
export function resultStatus(data) {
    if (data.status === 'done' && data.result.certificate_level == 'C1' && data.result.certificate_plan == 'pro') {
        return 'pro_excellent';
    }

    if (data.status === 'done' && data.result.certificate_level == 'C1' && data.result.certificate_plan == 'neop_plus') {
        return 'pro_plus_excellent';
    }

    if (data.result.status === 'passed') {
        return 'ct_passed';
    }

    if (data.result.status === 'review') {
        return 'ct_review';
    }

    if (data.result.status === 'failed') {
        if (data.attempt == 6) return 'ct_failed';
        if (data.result.certificate_level != data.result.levels[data.result.levels.length - 1] &&
            data.result.certificate_level != data.result.certificate_goal_level &&
            data.attempt == 3) return 'auto_next';
        return 'ct_landing_failed';
    }

    return $lang;
}


/**
* isSafariOld to detect browser is safari old version
* @return {boolean}
*/
// revisi
export function isSafariOld() {
    let oldSafari = false
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') != -1) {
        if (ua.indexOf('chrome') > -1) {
            oldSafari = false
        } else {
            var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
            // Safari 3.0 - 10 will return false
            if (!isSafari) {
                oldSafari = true
            }
        }
    }
    return oldSafari
}

/**
 * remove alert message
 */
export function removeMessage() {
    const found = document.getElementById("exit-warning")
    if (found) found.click()
}

/**
 *
 * @param {string} email
 * @param {string} token
 * @param {string} type
 * @param {string} fullname
 * @param {string} dial_code
 * @param {string} phone_number
 * @param {boolean} devMode
 * @param {string} level
 * @return  {object}
 */
// revisi
export function setFormData(email, token, type, fullname, dial_code, phone_number, devMode, level, pre_test) {
    let formData = {
        type: type,
        token: token,
        fullname: fullname,
        email: email,
        dial_code: dial_code,
        phone_number: phone_number,
        etest: devMode,
        level: level,
        pre_test: pre_test,
    }
    return formData
}

/**
 *
 * @param {any} formData
 * @returns {object}
 */
export function getFromData(formData) {
    try {
        let newFormData = {
            type: formData.get('type'),
            token: formData.get('token'),
            fullname: formData.get('fullname'),
            email: formData.get('email'),
            dial_code: formData.get('dial_code'),
            phone_number: formData.get('phone_number'),
            etest: formData.get('etest'),
            level: formData.get('level'),
            pre_test: formData.get('pre_test'),
        }
        return newFormData
    } catch (e) {
        let newFormData = {
            type: formData['type'],
            token: formData['token'],
            fullname: formData['fullname'],
            email: formData['email'],
            dial_code: formData['dial_code'],
            phone_number: formData['phone_number'],
            etest: formData['etest'],
            level: formData['level'],
            pre_test: formData['pre_test'],
        }
        return newFormData
    }
}

/**
 * getScriptURL()
 * find and get the script from neowidget
 * @returns string
 */
export function getScriptURL() {
    var script = document.querySelector('script[src*="neowidget.js"]')
    if (script) {
        var hostname;
        if (script.src.indexOf("//") > -1) {
            hostname = script.src.split('/')[0] + "//" + script.src.split('/')[2]
        } else {
            hostname = script.src.split('/')[0];
        }
        return hostname;
    }
    return ''
}

export function generateFingerprint() {
    const ua = navigator.userAgent;
    const screenRes = screen.width + 'x' + screen.height;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const language = navigator.language;

    const raw = ua + '|' + screenRes + '|' + timezone + '|' + language;

    return crypto.subtle.digest("SHA-256", new TextEncoder().encode(raw))
        .then(buffer => {
            return Array.from(new Uint8Array(buffer))
                .map(b => b.toString(16).padStart(2, '0'))
                .join('');
        });
}